import React from 'react';

import {
  ArrayInput,
  TextField,
} from 'react-admin';

import {
  Box,
  Card,
  CardHeader,
  Divider,
} from '@mui/material';

import Create from './dialog/Create';
import Edit from './dialog/Edit';

import DatagridIterator from '../../../../customFields/DatagridIterator';

const Goods = () => (
  <ArrayInput source="report.activity.goods_services" label={false}>
    <Box>
      <Card variant="outlined">
        <CardHeader title="Goods" />
        <Divider />
        <DatagridIterator
          resource="report.activity.goods_services"
          rowContent={[
            <TextField sortable={false} source="recordId" label="ID" key="recordId" />,
            <TextField sortable={false} source="item.item_type" label="Goods type" key="item.item_type" />,
            <TextField sortable={false} source="registrationNumber" label="Registration number" key="registrationNumber" />,
          ]}
          addDialogContent={(
            <Create />
          )}
          editDialogContent={(
            <Edit />
          )}
        />
      </Card>
    </Box>
  </ArrayInput>
);

export default Goods;
